/* eslint-disable react/prop-types */
import React from 'react'

import { Typography, Space } from 'antd'
import { PlayCircleOutlined } from '@ant-design/icons'

const { Text } = Typography

const VideoPlaceholder = ({ caption, ...props }) => {
	const { style = {}, ...rest } = props

	const defaultStyle = {
		width: '100%',
		height: 420,
		borderRadius: 16,
		background: '#f0f2f5',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
	const usedStyle = { ...defaultStyle, ...style }

	return (
		<div style={usedStyle} {...rest}>
			<Space direction="vertical" align="center">
				<PlayCircleOutlined style={{ fontSize: 64 }} />
				{caption ? (
					<Text type="secondary" style={{ color: 'inherit' }}>
						{caption}
					</Text>
				) : null}
			</Space>
		</div>
	)
}

export default VideoPlaceholder
